<template>
  <li @click.stop="expandMenu()" :class="{ expanded: expanded }">
    <font-awesome-icon class="nav-icon" v-if="hasIcon" :icon="item.icon" />
    <router-link
      v-if="hasRoute"
      :to="item.route"
      @click.native="contractMobileNavbar()"
    >
      <span>{{ item.text }}</span>
    </router-link>
    <a v-if="hasLink" :href="item.link" target="_blank">{{ item.text }}</a>
    <span v-if="hasChildren" class="submenu-name">{{ item.text }}</span>
    <span v-if="hasChildren" class="children-count">{{
      item.children.length
    }}</span>
    <ul v-if="expanded">
      <menu-item
        v-for="child in item.children"
        :key="child.id"
        :item="child"
      ></menu-item>
    </ul>
  </li>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      expanded: false,
      route: null
    };
  },

  computed: {
    ...mapState({
      mobileNavbar: state => state.navbar.mobileNavbar
    }),

    hasRoute: function() {
      if (_.has(this.item, "route")) {
        return true;
      }
      return false;
    },

    hasLink: function() {
      if (_.has(this.item, "link")) {
        return true;
      }
      return false;
    },

    hasChildren: function() {
      if (_.has(this.item, "children") && this.item.children.length > 0) {
        return true;
      }
      return false;
    },

    hasIcon: function() {
      if (_.has(this.item, "icon") && this.item.icon !== "") {
        return true;
      }
      return false;
    }
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions(["contractNavbar"]),

    expandMenu: function() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
      }
    },

    contractMobileNavbar() {
      this.$store.dispatch("contractNavbar");
    }
  }
};
</script>

<style scoped>
</style>
